import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_EXAM_MONITOR_GROUP + '/exam-group'
const reportUrl = process.env.VUE_APP_API_EXAM_MONITOR_GROUP + '/report'
const unblockUrl = process.env.VUE_APP_API_EXAM_MONITOR_GROUP + '/unblock'
const helperUrl = process.env.VUE_APP_API_EXAM_MONITOR_GROUP + '/helper'

const fetch = params => {
  return Repository(baseURL).fetch(params)
}

const count = params => {
  return Repository(baseURL + '/count').fetch(params)
}

const fetchOne = id => {
  return Repository(baseURL).fetchOne(id)
}

const create = params => {
  return Repository(baseURL).create(params)
}

const update = (id, params) => {
  return Repository(baseURL).update(id, params)
}

const remove = id => {
  return Repository(baseURL).delete(id)
}

const fetchSubmissionReport = params => {
  return Repository(reportUrl + '/submissions').create(params)
}

const fetchGroupStatReport = params => {
  return Repository(reportUrl + '/group-stats').create(params)
}

const unblockSubmission = (id, params = {}) => {
  return Repository(unblockUrl + '/submission').update(id, params)
}

const fetchCourses = params => Repository(helperUrl + '/search-courses').fetch(params)
const fetchGroups = params => Repository(helperUrl + '/search-groups').fetch(params)

export default {
  fetch,
  fetchOne,
  create,
  update,
  remove,
  count,
  fetchSubmissionReport,
  fetchGroupStatReport,
  unblockSubmission,
  //
  fetchCourses,
  fetchGroups,
}
